import { useAdminAuthStore } from '@/stores/adminAuthStore'

export function useAdminAuth() {
  const {
    user,
    token,
    isAuthenticated,
    isLoading,
    login,
    logout,
    refreshAccessToken,
    checkAuth,
  } = useAdminAuthStore()

  return {
    user,
    token,
    isAuthenticated,
    isLoading,
    login,
    logout,
    refreshAccessToken,
    checkAuth,
  }
}
